/* eslint-disable import/prefer-default-export */
export const MOBILE_COLOR_SWATCHES_TEST_KEY = 'pc_mobile_color_swatches_test';
